import React from 'react';
import clsx from 'clsx';
import {
  Segment, Header, Button, Icon,
} from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import FormattedHTMLMessage from '../FormattedHTMLMessage';

const NoRows = ({
  buttonIcon = 'plus',
  buttonText,
  className,
  entity,
  icon,
  loading,
  onClick,
  url,
}) => {
  const intl = useIntl();
  return (
    <Segment placeholder className={clsx('aridhia-no-rows', className)} loading={loading}>
      <Header icon>
        <Icon name={icon} className="primary" />
        <FormattedHTMLMessage
          id={loading ? `${entity}.loading.placeholder.title` : `${entity}.none.placeholder.title`}
        />
      </Header>
      {onClick && (
        <Button primary onClick={onClick} disabled={loading}>
          <Icon
            name={buttonIcon}
            className="primary"
            alt={intl.formatMessage({ id: `actions.create.${entity}.title` })}
          />
          {!buttonText && (<FormattedMessage id={`${entity}.none.placeholder.text`} />)}
          {buttonText}
        </Button>
      )}
      {url && (
        <Button primary as="a" href={url} disabled={loading}>
          <Icon
            name={buttonIcon}
            className="primary"
            alt={buttonText || intl.formatMessage({ id: `actions.create.${entity}.title` })}
          />
          {!buttonText && (<FormattedMessage id={`${entity}.none.placeholder.text`} />)}
          {buttonText}
        </Button>
      )}
    </Segment>
  );
};

export default NoRows;
